import { removeMiniCartFocus } from "./utils";
class User {

    constructor() {
        this.minicartContents = document.getElementById('minicart-content');
        this.minicartCount = document.getElementById('minicart-count');

        if (sessionStorage.getItem(window.storageSessionKey)) {
            this.onHaveUserData();
        } else {
            this.fetchUserData();
        }

        if (sessionStorage.getItem(window.storageCartKey)) {
            this.onHaveCartData();
        } else {
            this.fetchCartData();
        }
    }

    onHaveUserData() {
        const data = JSON.parse(sessionStorage.getItem(window.storageSessionKey));

        // show stuff based on logged in status
        if (data.loggedIn) {
            $('.logged-in-show').removeClass('logged-in-show');
        } else {
            $('.logged-out-show').removeClass('logged-out-show');
        }
    }

    onHaveCartData() {
        const data = JSON.parse(sessionStorage.getItem(window.storageCartKey));

        this.minicartContents.innerHTML = data;
        removeMiniCartFocus();

        const items = this.minicartContents.querySelectorAll('.mini_cart_item');
        this.minicartCount.textContent = items.length;
        // show stuff based on cart count
        if (!items) {
            $('.empty-cart-show').removeClass('empty-cart-show');
        } else {
            $('.filled-cart-show').removeClass('filled-cart-show');
        }

    }

    fetchUserData() {
        const self = this;
        $.ajax({
            method: 'post',
            url: "/wp-admin/admin-ajax.php",
            data: {
                'action': 'get_millborn_user_data'
            },
            success: function (data) {
                sessionStorage.setItem(window.storageSessionKey, data);
            },
            complete: function () {
                self.onHaveUserData();
            }
        });
    }

    fetchCartData() {
        const self = this;
        $.ajax({
            method: 'get',
            url: window.cartUrl,
            success: function (data) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const minicart = doc.body.querySelector('#minicart-content').innerHTML.replace(/[\n\t]/g, ''); // replace probably isn't needed here, just kinda nice to remove newline and tab characters
                sessionStorage.setItem(window.storageCartKey, JSON.stringify(minicart));
            },
            complete: function () {
                self.onHaveCartData();
            }
        });
    }

}
const user = new User();

$('body').on('updated_cart_totals wc_cart_emptied', function () {
    sessionStorage.removeItem(window.storageCartKey);
    user.fetchCartData();
});
